import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { registerVideoPdpEvent as registerVideo } from 'ggApp/modules/gaAnalytics/actions';
import { bindActionCreators } from 'redux';
import omitProps from 'ggApp/utils/omitProps';
import Player from './Player';

const enhance = compose(
    connect(null, (dispatch) => ({
        registerVideoPdpEvent: bindActionCreators(registerVideo, dispatch),
    })),
    withHandlers({
        onPlay: ({ registerVideoPdpEvent }) => () => registerVideoPdpEvent('videoPlayed'),
        onPause: ({ registerVideoPdpEvent }) => () => registerVideoPdpEvent('videoPaused'),
        onEnterCallback: ({ registerVideoPdpEvent }) => () =>
            registerVideoPdpEvent('videoImpression'),
    }),
    omitProps('registerVideoPdpEvent'),
);

export default enhance(Player);
